import { initialState } from "../initialState";
import * as Attachments from "./attachmentsActions";

export const attachmentsReducer = (state = initialState.attachments, action) => {
    switch (action.type) {
        case Attachments.SET_FILES_TO_UPLOAD:
            return { ...state, filesToUpload: action.filesToUpload };

        case Attachments.FETCH_ATTACHMENTS:
            return state;

        case Attachments.FETCH_ATTACHMENTS_SUCCEDED:
            return { ...state, workOrderAttachments: action.workOrderAttachments };

        case Attachments.FETCH_ATTACHMENTS_FAILED:
            return { ...state, workOrderAttachments: initialState.attachments.workOrderAttachments };

        case Attachments.FETCH_FOLLOWUP_ATTACHMENTS:
            return state;

        case Attachments.FETCH_FOLLOWUP_ATTACHMENTS_SUCCEDED:
            return {
                ...state,
                followupAttachments: {
                    ...state.followupAttachments,
                    [action.workOrderNumber]: action.attachments,
                },
            };

        case Attachments.FETCH_FOLLOWUP_ATTACHMENTS_FAILED:
            return { ...state, followupAttachments: initialState.attachments.followupAttachments };

        case Attachments.UPLOAD_ATTACHMENTS:
            return { ...state, filesToUpload: action.filesToUpload };

        case Attachments.UPDATE_ATTACHMENTS:
            return state;

        case Attachments.DELETE_ATTACHMENT:
            return state;
        case Attachments.CLEAR_ATTACHMENTS:
            return {
                ...state,
                workOrderAttachments: initialState.attachments.workOrderAttachments,
            };
        case Attachments.SET_FILE_UPLOAD_RES:
            return {
                ...state,
                fileUploadRes: action.response,
            };
        case Attachments.SET_FILE_UPDATE_RES:
            return {
                ...state,
                fileUpdateRes: action.response,
            };

        default:
            return state;
    }
};
